import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import QtMaterialButton from "components/QtMaterialButton";
import StatusLayout from "components/Status";
import { set } from "date-fns";
import DatatableComponent from "helpers/DatatableComponent";
import FormDialog from "helpers/FormDialog";
import { errorToast } from "helpers/Notification";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { currencyValues } from "store/helpers/common_functions";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";

const FundersAssignment = ({
  program,
  project,
  activityId,
  FetchDetails,
  onLoad,
}) => {
  const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [list, setList] = useState([]);
  const [id, setId] = useState();
  const [count, setCount] = useState(0);
  const [funders, setFunders] = useState([]);
  const [installmentOpen, setInstallmentOpen] = useState(false);
  const [isLoadingInstallments, setIsLoadingInstallments] = useState(false);
  const [installmentNumber, setInstallmentNumber] = useState(0);
  const [addInstallmentOpen, setAddInstallmentOpen] = useState(0);
  const [installmentId, setInstallmentId] = useState();

  const [installments, setInstallments] = useState([]);

  const [deleteOpen, setDeleteOpen] = useState(false);

  const onSuccess = () => setCount((v) => v + 1);
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  const query = program
    ? `programId=${program?.id}`
    : project
    ? `projectId=${project?.id}`
    : activityId
    ? `activityId=${activityId}`
    : "";

  useEffect(async () => {
    const fetchFunders = await FetchDetails(`/api/funder/list`);
    if (fetchFunders?.status) {
      setFunders(fetchFunders.data.data);
    }
  }, [program]);

  const fetchInstallments = async (id) => {
    setIsLoadingInstallments(true);
    const installments = await FetchDetails(
      `/api/installment/list?funderId=${id}`
    );
    setInstallments(installments?.data?.data);
    setIsLoadingInstallments(false);
  };

  const columns = [
    {
      name: "funder",
      label: "Funder Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-custom-blue text-xs ">{value?.name}</span>
        ),
      },
    },
    {
      name: "amount",
      label: "Amount Funded",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "fundType",
      label: "Funding Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="text-[#A1A1A1] text-xs font-lighter">{value}</span>
        ),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Installments",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const fund = list.find((x) => x.id === value);
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <Button
                sx={{
                  textTransform: "none",
                  fontSize: "0.75rem",
                  padding: "5px 10px",
                  backgroundColor: "#F3F4F6",
                  color: "#4B5563",
                }}
                onClick={() => {
                  setId(value);
                  setInstallmentOpen(true);
                  fetchInstallments(value);
                }}
                variant="contained"
                color="primary"
                size="small"
              >
                {fund?.installmentsCount ?? 0}
              </Button>
            </span>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">
            <IconButton
              onClick={() => {
                //   history.push(`/admin/project/details/${v}`);
              }}
            >
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="Decorative SVG"
                className={" mr-2 text-sm text-blueGray-300"}
              />
            </IconButton>

            <IconButton
              onClick={() => {
                setId(v);
                // set value
                setValue({
                  funderId: list.find((x) => x.id === v).funderId,
                  funderType: list.find((x) => x.id === v).fundType,
                  amount: list.find((x) => x.id === v).amount,
                  programId: list.find((x) => x.id === v).programId,
                  currency: list.find((x) => x.id === v).currency,
                });
                setOpen(2);
              }}
            >
              <img
                src={require("../../assets/icons/pencil.svg").default}
                alt="Decorative SVG"
                className={" mr-2 text-sm "}
                onClick={() => {
                  setId(v);
                  // set value
                  setValue({
                    funderId: list.find((x) => x.id === v).funderId,
                    funderType: list.find((x) => x.id === v).funderType,
                    amount: list.find((x) => x.id === v).amount,
                    programId: list.find((x) => x.id === v).programId,
                    currency: list.find((x) => x.id === v).currency,
                  });
                  setOpen(2);
                }}
              />
            </IconButton>
            <IconButton
              onClick={() => {
                setId(v);
                setDeleteOpen(true);
              }}
            >
              <img
                src={require("../../assets/icons/trash.svg").default}
                alt="Decorative SVG"
                className={" mr-2 text-sm "}
              />
            </IconButton>
          </div>
        ),
      },
    },
  ];

  return (
    <div>
      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={() => {
          onSuccess();
          onLoad();
        }}
        setOpen={setOpen}
        url={
          open === 1 ? "/api/funder/assign" : `/api/funder/assign/update/${id}`
        }
        title={open === 1 ? "Assign Funder" : "Edit Assign Funder"}
        fields={[
          {
            name: "funderId",
            label: "Funder",
            value: value["funderId"],
            values: funders.map((v) => {
              return { label: v.name, value: v.id };
            }),
            type: "select",
            required: true,
            col: 12,
            setValue: (val) => setValue0("funderId", val),
          },

          {
            name: "fundType",
            label: "Funding Type",
            value: value["fundType"],
            type: "radio",
            values: [
              { label: "Partially", value: "partial" },
              { label: "Full", value: "full" },
            ],
            required: true,
            col: 12,
            setValue: (val) => {
              if (val === "full") {
                setValue0("amount", project?.budget);
              } else {
                setValue0("amount", 0);
              }
              setValue0("fundType", val);
            },
          },
          {
            name: "amount",
            label: "Amount",
            value: value["amount"],
            type: value["fundType"] === "full" ? "text" : "number",
            isNumber: true,
            disabled: value["fundType"] === "full",
            setValue: (val) => {
              setValue0("amount", val);
            },
          },

          {
            name: program
              ? "programId"
              : activityId
              ? "activityId"
              : "projectId",
            label: "Program",
            value: program?.id ?? activityId ?? project?.id,
            required: false,
            type: "text",
            hidden: true,
            setValue: (val) =>
              setValue0(
                program ? "programId" : activityId ? "activityId" : "projectId",
                val
              ),
          },

          {
            name: "currency",
            label: "Currency",
            value: value["currency"],
            type: "select",
            values: currencyValues,
            // required: true,
            setValue: (val) => setValue0("currency", val),
          },
        ]}
      />

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={addInstallmentOpen > 0}
        onSuccess={async () => {
          await fetchInstallments(id);
          setAddInstallmentOpen(0);
        }}
        setOpen={setAddInstallmentOpen}
        url={
          addInstallmentOpen === 1
            ? "/api/installment/create"
            : `/api/installment/update/${installmentId}`
        }
        title={
          addInstallmentOpen === 1 ? "Add Installment" : "Edit Installment"
        }
        fields={[
          {
            name: "funderId",
            label: "Funder",
            value: value["funderId"],
            hidden: true,
            required: true,
            col: 12,
            setValue: (val) => setValue0("funderId", val),
          },
          {
            name: "amount",
            label: "Amount",
            value: value["amount"],
            type: value["fundType"] === "full" ? "text" : "number",
            isNumber: true,
            disabled: value["fundType"] === "full",
            setValue: (val) => {
              setValue0("amount", val);
            },
          },
          {
            name: "dueDate",
            label: "Due Date",
            value: value["dueDate"],
            type: "date",
            required: true,
            setValue: (val) => setValue0("dueDate", val),
          },
        ]}
      />

      <Dialog
        open={installmentOpen}
        onClose={() => setInstallmentOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="flex justify-between items-center">
            <h2>Installment(s)</h2>
            <IconButton onClick={() => setInstallmentOpen(false)}>
              <img
                src={require("../../assets/icons/close.svg").default}
                alt="Decorative SVG"
                className="w-6 h-6"
              />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="flex flex-col justify-between items-center">
            {!isLoadingInstallments && installments?.length > 0 ? (
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left"></th>
                    <th className="text-left">Amount</th>
                    <th className="text-left">Due Date</th>
                    <th className="text-left">Status</th>
                    <th className="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {installments.map((v, i) => (
                    <tr
                      style={{
                        backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#fff",
                        marginTop: "10px",
                      }}
                      key={i}
                    >
                      <td>Installment {i + 1}</td>

                      <td>{v.amount}</td>

                      <td>{moment(v.dueDate).format("DD/MM/YYYY")}</td>
                      <td>
                        <StatusLayout status="pending" />
                      </td>
                      <td>
                        <IconButton
                          onClick={() => {
                            setValue0("funderId", id);
                            setValue0("amount", v.amount);
                            setValue0(
                              "dueDate",
                              moment(v.dueDate).format("YYYY-MM-DD")
                            );
                            setInstallmentId(v.id);

                            setAddInstallmentOpen(2);
                          }}
                        >
                          <img
                            src={
                              require("../../assets/icons/pencil.svg").default
                            }
                            alt="Decorative SVG"
                            className="w-5 h-5"
                          />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : isLoadingInstallments ? (
              <div className="flex justify-center items-center w-full">
                <p>Loading Installments...</p>
              </div>
            ) : (
              <div className="flex justify-center items-center w-full">
                <p>No Installments Found</p>
              </div>
            )}

            <div className="flex justify-center items-center w-full mt-4">
              <QtMaterialButton
                onClick={() => {
                  setValue0("funderId", id);
                  setAddInstallmentOpen(1);
                }}
                className="mt-4"
                variant="contained"
                color="primary"
                size="small"
              >
                Add Installment
              </QtMaterialButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <DatatableComponent
        onAddNew={() => {
          // if funders there is any funder with funding type full
          const funder = list.find((x) => x.fundType === "full");
          if (funder) {
            errorToast("This Project has a funder with funding type full");
          } else {
            setOpen(1);
          }
        }}
        processData={(data) => {
          setList(data?.data);
          return data;
        }}
        onRowSelectionChange={(list) => {}}
        search={false}
        viewColumns={false}
        elevation={1}
        pdf={false}
        excel={false}
        columns={columns}
        url={`/api/funder/assigned?&count=${count}&${query}`}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(FundersAssignment);
